import { Suspense, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OTCPage from "pages/OTC";
import UserCabinet from "./UserCabinet/UserCabinet";
import * as Sentry from "@sentry/react";
import { useRoutes } from "react-router-dom";
import PrivateRoute from "../providers/PrivateRoute";
import SetUpPassword from "./SetUpPassword/SetUpPassword";
const useSentryRoutes = Sentry.wrapUseRoutesV6(useRoutes);

const AppRoutes = () =>
  useSentryRoutes([
    { path: "/", element: <OTCPage /> },
    {
      path: "/cabinet",
      element: <PrivateRoute element={<UserCabinet />} />,
    },
    {
      path: "/set-up-password",
      element: <SetUpPassword />,
    },
  ]);

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token =
      localStorage.getItem("Authorization") ||
      sessionStorage.getItem("Authorization");
    const currentPath = window.location.pathname;
    if (
      token &&
      currentPath !== "/cabinet" &&
      currentPath !== "/set-up-password"
    ) {
      navigate("/cabinet");
    } else if (
      !token &&
      currentPath !== "/" &&
      currentPath !== "/set-up-password"
    ) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="app">
      <Suspense fallback="Loading....">
        <AppRoutes />
      </Suspense>
    </div>
  );
};

export default App;
